import React, { useEffect, useState } from 'react';
import { Button } from './ui';
import { Clock } from 'lucide-react';
const CHECKOUT_URL = 'https://imperio-ia.impultienda.ar/checkout';
export function Pricing() {
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 59,
    s: 52
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.s > 0) return {
          ...prev,
          s: prev.s - 1
        };
        if (prev.m > 0) return {
          ...prev,
          m: prev.m - 1,
          s: 59
        };
        if (prev.h > 0) return {
          h: prev.h - 1,
          m: 59,
          s: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section className="py-12 px-4 bg-slate-950 relative" id="planes" data-id="element-158" data-mp="qjy2yxli45d5">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-brand-900/20 via-slate-950 to-slate-950 pointer-events-none" data-id="element-159" data-mp="ukqddu640gb0"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-160" data-mp="1jzajnumpildh">
        <div className="text-center mb-5" data-id="element-161" data-mp="1f18z159mudzw">
          <div className="inline-flex items-center gap-2.5 bg-red-500/15 text-red-400 border border-red-500/40 px-5 py-2.5 rounded-full font-bold mb-3 text-sm sm:text-base shadow-[0_0_20px_rgba(239,68,68,0.25)]" data-id="element-162" data-mp="1f4dcyucwgo3r">
            <Clock className="w-5 h-5 shrink-0 animate-pulse" data-id="element-163" data-mp="22rv7gxnju0af" />
            <span data-id="element-164" data-mp="22rbr3ldjrjyi">PRECIO DE LANZAMIENTO — CIERRA EN:</span>
            <span className="tabular-nums text-white text-base sm:text-lg font-black tracking-wide" data-id="element-165" data-mp="1xs8l9ypqt9ph">
              {String(timeLeft.h).padStart(2, '0')}:
              {String(timeLeft.m).padStart(2, '0')}:
              {String(timeLeft.s).padStart(2, '0')}
            </span>
          </div>
          <p className="text-amber-400 font-medium text-sm flex items-center justify-center gap-2" data-id="element-166" data-mp="2liw4hg53zlrc">
            ⚠️ Después sube a USD 49.99. No vuelve a bajar.
          </p>
          <div className="w-full max-w-md mx-auto mt-3 bg-slate-800 rounded-full h-1.5 overflow-hidden" data-id="element-167" data-mp="2gpt7sz51bw6x">
            <div className="bg-brand-500 h-full w-[72%]" data-id="element-168" data-mp="jt71i1qqxbqs"></div>
          </div>
          <p className="text-[11px] text-slate-500 mt-1.5" data-id="element-169" data-mp="jv9pkg8c8usv">
            72% de los cupos al precio de lanzamiento ya tomados
          </p>
        </div>

        <h2 className="text-2xl md:text-4xl font-bold text-center text-white mb-5" data-id="element-170" data-mp="a2ltxot3gwvq">
          ELEGÍ TU MEGAPACK
        </h2>

        {/* Plan selector */}
        <div className="flex flex-col gap-3 max-w-2xl mx-auto" role="radiogroup" aria-label="Elegí tu Megapack" data-id="element-171" data-mp="3sbcz6rj0gtju">
          <button type="button" role="radio" aria-checked={true} className="relative w-full text-left rounded-2xl border p-4 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-2 focus:ring-offset-slate-950 border-brand-500 bg-brand-900/15 shadow-[0_0_20px_rgba(6,182,212,0.25)]" data-id="element-172" data-mp="3ibugeeeu7dtd">
            <div className="flex items-start gap-3" data-id="element-173" data-mp="35zs4m3yc4ive">
              {/* Radio */}
              <span className="mt-0.5 shrink-0 w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors border-brand-400 bg-brand-500" aria-hidden="true" data-id="element-174" data-mp="311qgh4m1xtd2">
                <span className="w-2 h-2 rounded-full bg-white" data-id="element-175" data-mp="3aymt9mizh1nf"></span>
              </span>

              {/* Left content */}
              <div className="min-w-0 flex-1" data-id="element-176" data-mp="3op85wthugfcv">
                <h3 className="font-bold text-white text-base flex items-center gap-2 leading-tight" data-id="element-177" data-mp="3jshqm8dv5nsi">
                  <span className="shrink-0" data-id="element-178" data-mp="2ke64tz8d32n">
                    <span className="text-2xl leading-none" data-id="element-179" data-mp="2j33ixhiu1d4">🤖</span>
                  </span>
                  <span className="truncate" data-id="element-180" data-mp="3tqxhca8zav1h">MEGAPACK RECURSOS DIGITALES</span>
                </h3>
                <p className="text-brand-400 text-xs font-medium mt-0.5" data-id="element-181" data-mp="24bhl1vg5l3t0">
                  6 Tomos + 5 Bonos
                </p>
                <p className="text-slate-400 text-xs mt-1.5 leading-snug" data-id="element-182" data-mp="qf6hzxcf132v">
                  <span className="text-slate-500 font-medium" data-id="element-183" data-mp="qey0tt99fblv">
                    Ideal para:{' '}
                  </span>
                  Emprendedores, freelancers y profesionales que quieren crear
                  más rápido, automatizar procesos y vender utilizando
                  Inteligencia Artificial
                </p>
                <p className="text-[11px] font-medium mt-1.5 text-emerald-400" data-id="element-184" data-mp="7oyjxtnkp2tj">
                  Precio de lanzamiento
                </p>
              </div>

              {/* Right price column */}
              <div className="shrink-0 text-right pl-1" data-id="element-185" data-mp="gpmuufho6n27">
                <p className="text-slate-500 line-through text-xs leading-none mb-1" data-id="element-186" data-mp="go3hawneeq44">
                  USD 49.99
                </p>
                <p className="text-2xl sm:text-3xl font-black text-white leading-none" data-id="element-187" data-mp="3l3uteukm0u27">
                  USD 19.99
                </p>
                <p className="text-[10px] text-slate-400 mt-0.5" data-id="element-188" data-mp="3p451qdvvjwk8">pago único</p>
              </div>
            </div>
          </button>
        </div>

        {/* Single main CTA */}
        <div className="max-w-2xl mx-auto mt-5" data-id="element-189" data-mp="3cm2jx6mxux1v">
          <Button className="w-full text-base py-4 shadow-[0_0_20px_rgba(6,182,212,0.4)]" onClick={() => {
          window.location.href = CHECKOUT_URL;
        }} data-id="element-190" data-mp="3ckhrpno3jq76">
            → QUIERO MI MEGAPACK AHORA
          </Button>
          <p className="text-center text-xs text-slate-500 mt-2" data-id="element-191" data-mp="2ynus1d4relxk">
            Garantía 7 días · Pago seguro · Acceso en 5 minutos
          </p>
        </div>
      </div>
    </section>;
}